// §4.4 partial — admin/test-mode routes.
// Composer auto-collects this into routes.generated.ts.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const TestModePage = lazyWithRetry(() => import("./pages/TestModePage"));
const DefeatsPage = lazyWithRetry(() => import("./pages/DefeatsPage"));
const TradesOverridePage = lazyWithRetry(
  () => import("./pages/TradesOverridePage"),
);
const HistoryPage = lazyWithRetry(() => import("./pages/HistoryPage"));

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin/test-mode", Component: TestModePage },
      { path: "/admin/test-mode/history", Component: HistoryPage },
      { path: "/admin/test-mode/defeats", Component: DefeatsPage },
      { path: "/admin/test-mode/trades", Component: TradesOverridePage },
    ],
  },
];

export default routes;
